var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "summarize-timeline" },
    _vm._l(_vm.timeline, function (item) {
      return _c(
        "div",
        { key: item.id },
        [
          _c("summarize-timeline-item", {
            attrs: {
              id: "summarize-email-timeline-item-" + item.id,
              date: item.date,
              content: item.content,
            },
          }),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              attrs: {
                target: "summarize-email-timeline-item-" + item.id,
                triggers: "focus click",
                placement: "left",
                boundary: "window",
              },
              on: { show: _vm.closeAllPopovers },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "block",
                              "text-align": "center",
                              width: "100%",
                              "border-bottom": "1px solid gainsboro",
                              "padding-bottom": "5px",
                            },
                          },
                          [
                            _vm._v("\n          Original Email\n          "),
                            _c(
                              "button",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1px",
                                  left: "5px",
                                  background: "none",
                                  border: "none",
                                  "font-size": "1.5rem",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$root.$emit(
                                      "bv::hide::popover",
                                      "summarize-email-timeline-item-" + item.id
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n            ×\n          ")]
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _c("div", {
                staticStyle: {
                  width: "400px",
                  height: "500px",
                  overflow: "auto",
                },
                domProps: { innerHTML: _vm._s(item.emailBody) },
              }),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }